"use client";

import { useContext } from "react";

import { MediaContext } from "../providers";

export const usePlayer = () => useContext(MediaContext);
